module.exports = __webpack_public_path__ + "static/pad-img1-14cf6f1b790525b0877d943cf89f207c.png";